// @flow
import React from 'react';
import {connect} from 'react-redux';
import {
  setBigQueryStreamClearAllDiametrics as setBigQueryStreamClearAllDiametricsAction,
  setStreamDiametricsEditorFilterTextInput as setStreamDiametricsEditorFilterTextInputAction,
  setBigQueryStreamDiametricsChange as setBigQueryStreamDiametricsChangeAction,
  removeBigQueryStreamDiametrics as removeBigQueryStreamDiametricsAction,
} from 'bc/store/actions';
import * as selectors from 'bc/store/selectors';
import DimensionsAndMetricsEditor from 'bc/components/streams/editor/common/DimensionsAndMetricsEditor';

type PropTypes = {
  dimensions: Array<Object>,
  metrics: Array<Object>,
  filteredUnassignedColumns: Array<Object>,
  timeDefinitionArr: Array,
  filterTextInput: String,
  setBigQueryStreamClearAllDiametrics: Function,
  setStreamDiametricsEditorFilterTextInput: Function,
  setBigQueryStreamDiametricsChange: Function,
  removeBigQueryStreamDiametrics: Function,
  isStreamUpdating: Boolean,
};

class SqlDimensionsAndMetricsEditor extends React.PureComponent {
  props: PropTypes;

  render() {
    const {
      metrics,
      dimensions,
      filterTextInput,
      filteredUnassignedColumns,
      timeDefinitionArr,
      removeBigQueryStreamDiametrics,
      setStreamDiametricsEditorFilterTextInput,
      setBigQueryStreamDiametricsChange,
      setBigQueryStreamClearAllDiametrics,
      isStreamUpdating,
    } = this.props;

    return (
      <DimensionsAndMetricsEditor
        dimensions={dimensions}
        metrics={metrics}
        filteredUnassignedColumns={filteredUnassignedColumns}
        timeDefinitionArr={timeDefinitionArr}
        filterTextInput={filterTextInput}
        isStreamUpdating={isStreamUpdating}
        setStreamClearAllDiametrics={setBigQueryStreamClearAllDiametrics}
        setMetricDimentionEditorFilterTextInput={setStreamDiametricsEditorFilterTextInput}
        setStreamDiametricsChange={setBigQueryStreamDiametricsChange}
        removeStreamDiametrics={removeBigQueryStreamDiametrics}
      />
    );
  }
}

export default connect(
  (state) => ({
    dimensions: selectors.getBqStreamSelectedDimensions(state),
    metrics: selectors.getBqStreamSelectedMetrics(state),
    timeDefinitionArr: selectors.getBqStreamSelectedTimestampColumnArr(state),
    filterTextInput: selectors.getStreamMetricsDimentionsFilterTextInput(state),
    filteredUnassignedColumns: selectors.getFilteredBqStreamUnAssignedColumns(state),
    isStreamUpdating: selectors.getIsDataStreamUpdating(state),
  }),
  {
    setBigQueryStreamClearAllDiametrics: setBigQueryStreamClearAllDiametricsAction,
    setStreamDiametricsEditorFilterTextInput: setStreamDiametricsEditorFilterTextInputAction,
    setBigQueryStreamDiametricsChange: setBigQueryStreamDiametricsChangeAction,
    removeBigQueryStreamDiametrics: removeBigQueryStreamDiametricsAction,
  },
)(SqlDimensionsAndMetricsEditor);
